import {FeedbackAction} from '../_reducers/feedback';
import * as types from './types';

export function showFeedbackModal(): FeedbackAction {
    return {type: types.FEEDBACK_SHOW_MODAL}
}

export function hideFeedbackModal(): FeedbackAction {
    return {type: types.FEEDBACK_HIDE_MODAL}
}